import {List} from "./CardList.style"
export const CardList = ({ children }) => {
  return <List>{children}</List>; 
};
